package com.essntl.core.whatsapp.data.response

import kotlinx.serialization.Serializable

@Serializable
internal data class WhapiGroupsResponseDto(
    val groups: List<WhapiChatDto>,
)
